import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useUserStore } from '../store/modules/user'
import { trackEvent } from '@/utils/trackEvent'
const { trackEvent_PV } = trackEvent()
const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: '首页' },
    component: HomeView
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true, title: '个人中心' }
  },
  {
    path: '/apikey',
    name: 'apikey',
    component: () => import('../views/ApiKeyView.vue'),
    meta: { requiresAuth: true, title: 'API Key 管理' }
  },
  {
    path: '/skill/:id',
    name: 'skill-detail',
    component: () => import('../views/SkillDetailView.vue'),
    meta: { title: '技能详情' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫 - 检查登录状态
router.beforeEach((to, _, next) => {
  const userStore = useUserStore()

  // 如果没有用户信息，只允许进入首页
  if (!userStore.profile && to.path !== '/') {
    next('/')
    return
  }

  next()
})

router.afterEach((to) => {
  trackEvent_PV({
    wePageTitle: to.meta.title,
    pageUrl: to.path
  })
})
export default router
